import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import AboutSection1 from '../Components/About/PageSection1';
import PageSection2 from '../Components/About/PageSec2';
import Footer from '../Components/Footer';
import VisionMissionSection from '../Components/About/Section3';
import Loader from '../Components/Loader/Loader'; // Import the loader component
import { WhatsApp } from "@mui/icons-material"; // Import WhatsApp icon
import { IconButton } from "@mui/material";
import Header2 from '../Components/Header2';


function AboutUs() {
  // State to manage loading
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate a loading delay (e.g., for fetching data or animations)
    const timer = setTimeout(() => setIsLoading(false), 2000); // 2-second delay

    return () => clearTimeout(timer); // Cleanup timeout
  }, []);

  return (
    <div>
      {isLoading ? (
        // Render Loader while loading
        <Loader />
      ) : (
        // Render the main content once loading is complete
        <>
          <Header2 />
          <div style={{ marginTop: '90px' }}>
            <AboutSection1 />
          </div>
          <div>
            <PageSection2 />
          </div>
          <div>
            <VisionMissionSection />
          </div>
          <Footer />
           {/* WhatsApp icon at the bottom-right */}
           <IconButton
            href="https://wa.me/+971524346217"
            target="_blank"
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              backgroundColor: "#25D366",
              borderRadius: "50%",
              padding: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <WhatsApp style={{ color: "#fff", fontSize: "35px" }} />
          </IconButton>
        </>
      )}
    </div>
  );
}

export default AboutUs;
